import Capa from './Capa';

const ESTADOS_LAYER_NAME = 'vih:estados_poligonos'

//
export default class Estados extends Capa {

  constructor() {
    super({
      capa: ESTADOS_LAYER_NAME, 
      titulo: 'Límites estatales',
      z_index: 2,
    })
  }

}